import React, { FC } from "react";
import { Button } from "@xometry/xometry_loft";
import { SuccessStepContainer } from "./CustomerRFQ.style";

const SuccessStepSVG = () => {
  return (
    <svg
      width="228"
      height="164"
      viewBox="0 0 228 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2318_6795)">
        <path
          d="M199.691 149.231C204.684 142.828 205.196 134.033 210.492 127.745C217.208 118.637 228.228 111.001 227.737 98.4878C228.123 76.1142 198.312 75.0174 188.4 58.4827C175.949 37.4774 159.634 14.6651 132.194 16.1483C120.308 16.3259 107.805 20.5144 96.9419 15.6992C83.9689 8.48153 70.5782 -9.69311 56.3205 6.62228C48.7268 14.498 50.9934 22.0185 50.2414 31.7221C51.4217 66.2539 -15.0202 60.6762 3.13356 98.1744C14.0175 119.117 43.7131 107.46 58.2529 120.914C64.9378 127.588 65.6376 138.065 69.847 146.525C82.5902 172.419 112.244 164.251 133.845 155.665C152.698 147.319 187.972 159.738 199.681 149.251L199.691 149.231Z"
          fill="#E6F0FD"
        />
        <path
          d="M82.6215 100.378L143.047 135.714C143.204 135.808 143.402 135.694 143.392 135.516L143.277 93.6203C143.277 93.5367 143.235 93.4636 143.162 93.4218L82.5693 58.5558C82.4126 58.4618 82.2246 58.5767 82.2246 58.7542L82.4544 100.065C82.4544 100.19 82.517 100.305 82.6319 100.368L82.6215 100.378Z"
          fill="#86B5F8"
        />
        <path
          d="M82.3917 58.5349L143.454 93.6725L112.516 39.4724C112.087 38.7203 111.116 38.5114 110.416 39.0232L82.3917 58.5349Z"
          fill="#86B5F8"
        />
        <path
          opacity="0.5"
          d="M153.677 138.261C156.663 132.958 141.594 118.812 120.019 106.665C98.4437 94.5177 78.5333 88.9698 75.5475 94.2731C72.5617 99.5764 87.6312 113.723 109.206 125.869C130.781 138.016 150.691 143.564 153.677 138.261Z"
          fill="#C3DAFD"
        />
        <path
          d="M136.581 115.075V62.4309C136.581 60.7284 135.359 58.6289 133.876 57.7724C133.793 57.7202 101.465 39.1382 101.13 38.9606C100.274 38.5114 99.971 38.2712 99.386 38.2085C98.9473 38.1668 97.3806 39.2844 96.9105 39.556C95.9705 40.0991 95.0199 40.6318 94.0694 41.1541C92.1893 42.1986 90.3092 43.2431 88.4395 44.3085C88.1992 44.4443 88.0634 44.7472 88.0634 45.1337C88.0634 59.1511 88.0634 99.8874 88.0634 99.9919C88.0634 101.694 89.2646 103.773 90.7583 104.63L134.461 129.855C135.662 130.544 136.634 130.001 136.634 128.633V119.89L136.602 115.054L136.581 115.075ZM133.542 128.121L91.1239 103.627C89.9854 102.969 89.0662 101.371 89.0662 100.044V48.4553C89.0662 47.0347 90.0794 46.4707 91.3328 47.1914L97.1717 50.5652C98.7175 51.4635 99.9814 50.7532 99.9814 48.9984V40.0782C99.9814 39.9215 100.034 39.7962 100.138 39.744L100.305 39.65C100.41 39.5873 100.545 39.6082 100.681 39.6918L133.521 58.6498C134.659 59.3078 135.579 60.9059 135.579 62.2325V113.78L135.61 118.459V126.92C135.61 128.246 134.691 128.779 133.552 128.121H133.542Z"
          fill="#86B5F8"
        />
        <path
          d="M89.3587 45.4679C89.1289 45.6037 88.9931 45.8962 88.9931 46.2722C88.9931 59.9032 88.9931 99.5009 88.9931 99.595C88.9931 101.245 90.1525 103.261 91.5835 104.086L133.709 128.403C134.868 129.071 135.798 128.539 135.798 127.212V118.72L135.767 114.02V62.8488C135.767 61.1984 134.597 59.1616 133.155 58.3364C133.072 58.2842 101.914 40.3811 101.59 40.2036C100.765 39.7753 100.472 39.5351 99.9083 39.4829C99.4801 39.4411 97.9759 40.5378 97.5164 40.7989C96.6076 41.3317 95.6884 41.8539 94.7797 42.3657C92.9727 43.3998 91.1552 44.413 89.3482 45.4575L89.3587 45.4679Z"
          fill="#E6E9EC"
        />
        <path
          d="M134.837 117.3L134.806 112.745V62.6399C134.806 61.3551 133.918 59.7988 132.821 59.1721L101.172 40.9034C101.036 40.8198 100.901 40.8094 100.807 40.8721L100.639 40.9661C100.545 41.0183 100.493 41.1436 100.493 41.2899V49.9594C100.493 51.6724 99.2816 52.3618 97.7879 51.4948L92.158 48.2464C90.9568 47.5466 89.9749 48.1106 89.9749 49.4894V99.6367C89.9749 100.922 90.8628 102.478 91.9595 103.105L132.842 126.711C133.939 127.348 134.827 126.815 134.827 125.53V117.31L134.837 117.3Z"
          fill="white"
        />
        <path
          d="M99.2712 39.629L99.3861 48.215C99.407 49.6669 98.4147 50.2936 97.1821 49.5938L89.86 45.4992C89.6407 45.3739 89.5258 44.9979 89.6825 44.9039L98.8534 39.1799C99.01 39.0859 99.2712 39.3679 99.2816 39.6186L99.2712 39.629Z"
          fill="white"
        />
        <path
          d="M99.0205 39.1904C99.1458 39.2635 99.2712 39.4411 99.2712 39.6186L99.3861 48.2046C99.4069 49.6565 98.4146 50.2832 97.1821 49.5833L89.86 45.4888C89.6407 45.3635 89.5258 44.9875 89.6825 44.8934L98.8533 39.1695C98.8533 39.1695 98.9682 39.1486 99.0309 39.1799L99.0205 39.1904ZM99.0309 38.5741C98.822 38.4488 98.6236 38.4383 98.4773 38.5323L89.3064 44.2563C89.0871 44.3921 89.0244 44.7368 89.1498 45.1441C89.2751 45.541 89.5467 45.9171 89.86 46.1051L97.203 50.21C98.728 51.0666 99.9501 50.3041 99.9292 48.5075L99.8143 39.9215C99.8143 39.4202 99.4696 38.8352 99.0414 38.5845L99.0309 38.5741Z"
          fill="#86B5F8"
        />
        <path
          d="M125.175 71.0482L100.326 56.707C99.9501 56.4876 99.7203 55.9445 99.8143 55.5058C99.9083 55.0671 100.305 54.8791 100.681 55.0984L125.53 69.4397C125.906 69.659 126.136 70.2022 126.042 70.6409C125.948 71.0796 125.551 71.2676 125.175 71.0482Z"
          fill="#4B91F5"
        />
        <path
          d="M129.813 81.5874L95.4482 61.7416C95.0408 61.5118 94.717 60.9373 94.717 60.4777C94.717 60.0077 95.0408 59.8196 95.4482 60.0599L129.813 79.9058C130.22 80.1355 130.544 80.71 130.544 81.1696C130.544 81.6397 130.22 81.8277 129.813 81.5874Z"
          fill="#C3DAFD"
        />
        <path
          d="M129.813 88.147L95.4482 68.3011C95.0408 68.0713 94.717 67.4969 94.717 67.0373C94.717 66.5672 95.0408 66.3792 95.4482 66.6195L129.813 86.4653C130.22 86.6951 130.544 87.2696 130.544 87.7292C130.544 88.1992 130.22 88.3872 129.813 88.147Z"
          fill="#C3DAFD"
        />
        <path
          d="M129.813 94.6961L95.4482 74.8503C95.0408 74.6205 94.717 74.046 94.717 73.5864C94.717 73.1164 95.0408 72.9283 95.4482 73.1686L129.813 93.0145C130.22 93.2443 130.544 93.8187 130.544 94.2783C130.544 94.7484 130.22 94.9364 129.813 94.6961Z"
          fill="#C3DAFD"
        />
        <path
          d="M82.6319 58.6185L111.231 93.777C111.294 93.8605 84.9508 99.783 82.5379 100.316C82.4439 100.337 82.3604 100.263 82.3604 100.169L82.1932 58.7647C82.1932 58.5349 82.4857 58.4304 82.6319 58.608V58.6185Z"
          fill="#C3DAFD"
        />
        <path
          d="M87.5829 98.3937C85.3163 99.1562 83.5093 99.8352 82.6841 100.044C82.4126 100.117 82.3499 100.201 82.3603 99.9187C82.4752 94.9259 82.1201 58.7333 82.2559 58.5244C82.2977 58.4618 82.4439 58.5035 82.5379 58.5975C82.9557 59.0362 83.7182 59.9972 84.0838 60.4255C84.0838 60.4255 83.6555 80.898 84.7941 89.3273C85.5148 94.6439 86.0684 95.6467 87.5725 98.3833L87.5829 98.3937Z"
          fill="#96BFF9"
        />
        <path
          d="M143.214 93.7456L143.381 135.506C143.381 135.735 143.099 135.829 142.953 135.652L111.408 93.871C111.294 93.7143 111.408 93.4845 111.596 93.4845L142.974 93.5158C143.099 93.5158 143.214 93.6203 143.214 93.7561V93.7456Z"
          fill="#C3DAFD"
        />
        <path
          d="M82.5171 100.66L142.995 135.673C143.172 135.777 143.371 135.558 143.256 135.391L112.275 90.915C111.899 90.3927 111.032 90.2465 110.416 90.6016L82.5693 100.107C82.3186 100.19 82.2873 100.525 82.5171 100.66Z"
          fill="#C3DAFD"
        />
        <path
          d="M112.161 90.7792C111.962 90.4972 111.398 90.2778 110.824 90.4449C110.103 90.6538 87.9381 98.2475 87.9381 98.2475L82.5588 100.044C82.2873 100.138 82.2455 100.504 82.4962 100.65L142.932 135.704C143.141 135.829 143.381 135.579 143.235 135.38C139.349 129.886 117.644 98.6444 112.307 90.9985C112.286 90.9672 112.202 90.8418 112.14 90.7687L112.161 90.7792ZM88.9722 100.472C88.6902 100.055 88.8782 99.5009 89.3482 99.3233C92.7429 97.9759 106.071 93.004 110.865 91.3537C111.001 91.3119 111.262 91.2283 111.335 91.2283C111.534 91.2283 111.628 91.385 111.711 91.4686C111.879 91.6461 133.281 122.992 138.754 131.066C139.067 131.526 138.545 132.079 138.065 131.808C128.998 126.585 89.4004 101.078 88.9826 100.462L88.9722 100.472Z"
          fill="#96BFF9"
        />
        <path
          d="M142.713 30.6671L163.54 56.028C163.593 56.0907 163.697 56.0803 163.728 55.9967L170.486 37.5609C170.486 37.5609 170.486 37.4878 170.466 37.4565L149.481 12.2836C149.429 12.2209 149.324 12.2418 149.293 12.3149L142.681 30.5209C142.66 30.5731 142.681 30.6358 142.713 30.6776V30.6671Z"
          fill="#FFF5DA"
        />
        <path
          d="M149.408 12.2209L170.549 37.5923L165.744 8.73219C165.682 8.33527 165.285 8.08458 164.898 8.18904L149.408 12.2209Z"
          fill="#FFDE82"
        />
        <path
          opacity="0.4"
          d="M149.502 12.3045L156.365 32.4115C156.365 32.4115 143.83 30.782 142.681 30.6253C142.64 30.6253 142.608 30.5731 142.629 30.5313L149.283 12.294C149.325 12.1896 149.46 12.2 149.502 12.294V12.3045Z"
          fill="#FFD152"
        />
        <path
          d="M145.22 30.594C144.102 30.5627 143.193 30.5627 142.796 30.5209C142.66 30.5104 142.629 30.5313 142.671 30.4164C143.538 28.2438 149.251 12.2627 149.356 12.2C149.387 12.1791 149.439 12.2209 149.471 12.2731C149.586 12.5343 149.763 13.0774 149.857 13.3281C149.857 13.3281 146.348 22.2587 145.481 26.1548C144.938 28.6094 145.011 29.1421 145.23 30.594H145.22Z"
          fill="#FFD152"
        />
        <path
          opacity="0.4"
          d="M170.434 37.5923L163.728 55.9862C163.687 56.0907 163.551 56.0803 163.52 55.9862L156.438 32.4846C156.406 32.401 156.5 32.3174 156.584 32.3488L170.372 37.4565C170.424 37.4774 170.455 37.54 170.434 37.6027V37.5923Z"
          fill="#FFD152"
        />
        <path
          d="M142.619 30.7715L163.53 55.9967C163.593 56.0698 163.718 56.0071 163.687 55.9131L157.294 31.3251C157.211 31.0327 156.855 30.8238 156.532 30.8864L142.744 30.5417C142.619 30.5417 142.556 30.6775 142.629 30.7715H142.619Z"
          fill="#FFE08B"
        />
        <path
          d="M157.263 31.2416C157.221 31.0849 157.012 30.8969 156.73 30.876C156.375 30.8551 145.397 30.594 145.397 30.594L142.744 30.5104C142.608 30.5104 142.535 30.6671 142.619 30.7716L163.499 56.0072C163.572 56.0907 163.718 56.028 163.687 55.9131C162.872 52.8632 158.401 35.5972 157.294 31.3774C157.294 31.3669 157.273 31.2938 157.263 31.252V31.2416ZM145.491 31.7325C145.439 31.5027 145.606 31.2938 145.846 31.2834C147.559 31.2416 154.223 31.2207 156.605 31.2834C156.678 31.2834 156.793 31.2834 156.835 31.3043C156.918 31.3356 156.939 31.4192 156.96 31.4714C157.002 31.5758 161.326 48.8418 162.412 53.281C162.475 53.5316 162.151 53.6883 161.984 53.4899C158.84 49.7191 145.575 32.0772 145.491 31.7325Z"
          fill="#FFD152"
        />
        <path
          d="M32.1712 72.5523L50.9934 51.944L68.3534 55.6207L49.5102 76.229L32.1712 72.5523Z"
          fill="#FFD152"
        />
        <path
          d="M32.6099 72.2181L50.5443 52.2782L66.2643 55.6833C66.609 55.7565 66.703 56.0385 66.4628 56.2996L49.3327 75.1218C49.1551 75.3203 48.894 75.4039 48.6328 75.3516L32.5995 72.2076L32.6099 72.2181Z"
          fill="#FFDD81"
        />
        <g opacity="0.8">
          <path
            opacity="0.8"
            d="M32.1608 72.4583L50.6279 64.2066L51.0143 51.8604L32.1608 72.4583Z"
            fill="#FFD152"
          />
          <path
            opacity="0.8"
            d="M32.1608 72.4583L49.74 63.7679L50.983 51.944L32.1608 72.4583Z"
            fill="#FFEBB6"
          />
        </g>
        <path
          d="M179.96 82.8304L166.517 64.5095L153.053 66.3479L166.507 84.6792L179.96 82.8304Z"
          fill="#FFC118"
        />
        <path
          d="M179.636 82.5275L166.841 64.8124L154.652 66.5463C154.38 66.5881 154.296 66.8075 154.474 67.0373L166.705 83.7705C166.831 83.9376 167.029 84.0316 167.228 84.0107L179.647 82.517L179.636 82.5275Z"
          fill="#FFE8AA"
        />
        <g opacity="0.8">
          <path
            opacity="0.8"
            d="M179.971 82.7573L166.214 74.6727L166.507 64.4364L179.971 82.7573Z"
            fill="#FFD152"
          />
          <path
            opacity="0.8"
            d="M179.971 82.7573L166.914 74.3593L166.517 64.5095L179.971 82.7573Z"
            fill="#FFE292"
          />
        </g>
        <path
          d="M65.1676 20.7233L81.9217 27.9513L83.2482 39.3157L66.4837 32.0667L65.1676 20.7233Z"
          fill="#FFD152"
        />
        <path
          d="M65.4601 20.9218L81.3159 27.7529L82.4648 38.0205C82.4857 38.2503 82.3395 38.3548 82.1306 38.2712L67.1208 31.7012C66.9642 31.6385 66.8597 31.4923 66.8388 31.3252L65.4705 20.9218H65.4601Z"
          fill="#FFE8AA"
        />
        <g opacity="0.66">
          <path
            opacity="0.7"
            d="M65.2198 20.692L74.2027 30.2702L81.9843 27.9409L65.2198 20.692Z"
            fill="#FFC118"
          />
          <path
            opacity="0.66"
            d="M65.2198 20.692L74.2967 29.633L81.9217 27.9409L65.2198 20.692Z"
            fill="#FFE292"
          />
        </g>
        <path
          d="M104.974 26.6039C101.726 12.6178 116.307 3.57228 128.789 4.51235C133.009 4.79437 137.177 6.39248 140.477 9.11868C140.822 9.4007 140.874 9.91251 140.592 10.2572C140.31 10.6019 139.788 10.6437 139.443 10.3512C136.456 7.77125 132.654 6.19402 128.685 5.83889C116.788 4.66902 102.687 13.0565 105.517 26.4681C105.611 26.8024 105.058 26.9591 104.974 26.6039Z"
          fill="#86B5F8"
        />
        <path
          d="M155.79 99.8143C166.089 105.496 179.26 101.59 186.76 93.0771C190.531 89.0139 193.602 83.6765 193.215 78.0152C192.85 72.5628 188.598 67.3715 183.23 66.4523C182.237 66.2852 182.498 64.7602 183.491 64.9273C189.601 66.0867 194.155 71.8316 194.5 77.9316C194.866 89.5466 183.271 100.138 172.555 102.572C166.841 103.825 160.637 103.188 155.518 100.274C155.236 100.086 155.466 99.6576 155.78 99.8143H155.79Z"
          fill="#86B5F8"
        />
        <path
          d="M96.7747 21.5589C88.4812 5.17038 66.1076 2.80977 50.2832 8.25172C44.1518 10.7272 37.2476 15.2813 36.7149 22.4467C36.4328 27.8573 39.8066 32.495 45.3217 33.0068C47.7659 33.3202 50.5234 33.1948 52.4035 31.5027C54.1166 29.8419 55.1402 27.1575 54.2837 24.8387C52.3095 20.0548 45.844 18.7909 41.1958 19.731C32.6726 21.6425 26.1861 30.0404 26.301 38.7621C26.3219 45.75 29.9255 52.5916 35.5032 56.801C35.8584 57.0308 35.4405 57.6157 35.1063 57.3337C29.3301 53.0303 25.5803 46.0215 25.5072 38.7621C25.246 27.8365 35.2525 17.2241 46.4602 18.5298C53.845 18.9267 59.1929 26.3428 53.2078 32.3488C51.0561 34.3125 47.8808 34.5005 45.165 34.1349C41.4779 33.7275 37.8429 31.4296 36.5582 27.826C34.2393 22.5721 36.4642 16.3676 40.6631 12.8163C48.9253 5.5673 60.5612 3.93785 71.1631 4.95103C81.7963 5.8911 92.8473 11.1555 97.5999 21.1829C97.8192 21.7156 97.0672 22.0916 96.7956 21.5693L96.7747 21.5589Z"
          fill="#86B5F8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2318_6795">
          <rect width="227.757" height="164" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

interface Props {
  onClose: () => void;
}

export const SuccessStep: FC<Props> = props => {
  const { onClose } = props;
  return (
    <SuccessStepContainer>
      <SuccessStepSVG />
      <h5>Your request has been sent!</h5>
      <p>
        Your Quote Request has been successfully sent. One of our
        <br />
        representatives will be in touch with you shortly.
      </p>
      <Button kind="primary" onClick={onClose}>
        Close
      </Button>
    </SuccessStepContainer>
  );
};
